
<div class="d-flex justify-content-center login">

    <div class="card">
     <div class="card-body title bg-primary" >
      <div class="title-header">
        <h1 class="">Presby Connect Admin</h1>
      <h4>powered by IaktechConsult LLC</h4> 
      </div>
      
     
    </div>
    
      <div class="card-body">
    
        <div >
          <h2>Welcome</h2> 
          <div class="img-el"><img src="assets/logo.png" width="150" height="150"></div>
          @if(authService.errorMessages){
        <div class="alert alert-danger m-3" role="alert">{{authService.errorMessages}}</div>
    }
       <form class="from-deco"  [formGroup]="userForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="email" class="form-label">Email address</label>
              <input class="form-control" id="email" type="email" formControlName="email"  [ngClass]="{'is-invalid':userForm.get('email').errors && userForm.get('email').touched}">  
               @if(userForm.get('email').invalid &&
               userForm.get('email').dirty || userForm.get('email').touched ){
            
                <small *ngIf="userForm.get('email').errors">Email is required.</small>
               }
            </div>
            <div class="form-group">
              <label for="password" class="form-label">Password</label>
              <input class="form-control" id="password" type="password" formControlName="password" [ngClass]="{'is-invalid':userForm.get('password').errors && userForm.get('password').touched}">
          @if(userForm.get('password').invalid && userForm.get('password').touched){
                <small *ngIf="userForm.get('password').errors">Password is required.</small>
                
                }
            </div>
           
            <button type="submit" class="btn btn-primary"  [disabled]="!userForm.valid" >Submit</button>
          </form> 
        </div>
      </div>
        
          
    </div>
    </div>